/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type DepartmentDropdown_departments = ReadonlyArray<{
    readonly node: {
        readonly id: string;
        readonly name: string | null;
    } | null;
    readonly " $refType": "DepartmentDropdown_departments";
}>;
export type DepartmentDropdown_departments$data = DepartmentDropdown_departments;
export type DepartmentDropdown_departments$key = ReadonlyArray<{
    readonly " $data"?: DepartmentDropdown_departments$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"DepartmentDropdown_departments">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "DepartmentDropdown_departments",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DepartmentType",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DepartmentTypeEdge"
};
(node as any).hash = '7544d13ec178cb3f650ffe1bb2b14683';
export default node;
